import {gpsControlAllows,validGpsInterval} from './gps-control-profile.js';
import {reportedGpsParameters} from './gps-parameters.js';

// Only an independent, model-bound TIMER read can confirm a stored pair.
// The write acknowledgement and physical reporting cadence remain separate.
export function gpsIntervalReadbackStatus(profile,expected,reply) {
 if(!gpsControlAllows(profile,'interval')||!profile?.gpsControl?.timerPair||!validGpsInterval(expected,profile.gpsControl))return 'unconfirmed';
 const fields=reportedGpsParameters(reply,{profile,query:'interval'});
 if(fields.length!==2)return 'unconfirmed';
 return fields.every(field=>Number(field.value)===expected[field.key])?'confirmed':'mismatch';
}

export function gpsVerifiedIntervalFeedback(verification,danish) {
 const status=verification?.status;
 const messages=status==='confirmed'
  ? ['Intervallet er gemt og bekræftet af trackeren.','The interval is saved and confirmed by the tracker.']
  :status==='mismatch'
   ? ['Trackeren har gemt et andet interval end det valgte. Ændringen er ikke bekræftet.','The tracker reports a different interval from your selection. The change is not confirmed.']
   :status==='pending'
    ? ['Gemmer og kontrollerer intervallet…','Saving and checking the interval…']
    : ['Bekræftelsen mangler. Intervallet kan være ændret, men kunne ikke kontrolleres.','Confirmation is missing. The interval may have changed, but could not be checked.'];
 return {success:status==='confirmed',message:messages[danish?0:1]};
}

// Compare independent reads by their observation time. A write ACK alone never
// establishes a current setting; a newer read wins even if it differs from it.
export function currentGpsInterval(profile,readback,lastWrite){
 const reads=[readback,lastWrite?.verification&&{reply:lastWrite.verification.reply,finishedAt:lastWrite.verification.finishedAt,status:lastWrite.verification.status}];
 const values=reads.filter(r=>r&&r.reply&&!['pending','rejected','unconfirmed'].includes(r.status)).map(r=>{
  const fields=reportedGpsParameters(r.reply,{profile,query:'interval'});
  const pair=Object.fromEntries(fields.filter(f=>f.value!==null).map(f=>[f.key,Number(f.value)]));
  const at=Date.parse(r.finishedAt??'');
  return Number.isFinite(at)&&validGpsInterval(pair,profile?.gpsControl)?{accOn:pair.accOn,accOff:pair.accOff,at:new Date(at).toISOString()}:null;
 }).filter(Boolean).sort((a,b)=>b.at.localeCompare(a.at));
 return values[0]??null;
}
